export const GO_TO_MESSAGE = 'GO_TO_MESSAGE';
export const READ_MESSAGE = 'READ_MESSAGE';
export const COUNT_UNREAD_MESSAGES = 'COUNT_UNREAD_MESSAGES';
export const MAKE_AS_UNREAD_MESSAGE = 'MAKE_AS_UNREAD_MESSAGE';
